import { createBrowserRouter } from 'react-router-dom';
import RootLayout from './layouts/root.layout.js';
import HomePage from './pages/HomePage.js';
import ErrorPage from './pages/ErrorPage.js';
import { ErrorBoundaryComponent } from './components/ErrorBoundaryComponent.js';
import ExitIframe from './pages/ExitIframe.jsx';
import { ManageWidgetPage } from './pages/ManageWigetPage.js';
import { SupportPage } from './pages/support.page.js';

export const router = createBrowserRouter([
    {
        path: '/',
        Component: RootLayout,
        ErrorBoundary: () => <ErrorPage />,
        children: [
            {
                index: true,
                Component: () => <HomePage />,
                ErrorBoundary: () => <ErrorBoundaryComponent />,
            },
            {
                path: 'manage-widget',
                Component: () => <ManageWidgetPage />,
                ErrorBoundary: () => <ErrorBoundaryComponent />,
            },
            {
                path: 'exitiframe',
                Component: () => <ExitIframe />,
                ErrorBoundary: () => <ErrorBoundaryComponent />,
            },
            {
                path: 'support',
                Component: () => <SupportPage />,
                ErrorBoundary: () => <ErrorBoundaryComponent />,
            },
        ],
    },
]);
